module.exports = __webpack_public_path__ + "vertigo.67c60ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/vertigo.jpg
// module id = qjcU
// module chunks = 0